//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { axiosPost } from '../../axios/axios.js'
import ReportRoadsFilesSelectionDialog from './ReportRoadsFilesSelectionDialog.vue'

export default {
  components: {
    ReportRoadsFilesSelectionDialog: ReportRoadsFilesSelectionDialog
  },
  props: {
    reportRoadsFiles: {
      type: Array,
      default () {
        return []
      }
    },
    reportsDocuments: {
      type: Array,
      default () {
        return []
      }
    },
    reportRoadsTransmitted: {
      type: Boolean,
      default: false
    },
    reportRoadsTransmittedByEmail: {
      type: Boolean,
      default: false
    },
    reportRoadsId: {
      type: Number,
      default: null
    }
  },
  data: function () {
    return {
      tabFilesToUpload: [],
      filesToUpload: [],
      reportRoadsFilesSelectionDialogOpened: false,
      loading: false
    }
  },
  methods: {
    onConfirm: function (files) {
      this.$emit('selected-files-changed', files)
      this.reportRoadsFilesSelectionDialogOpened = false
    },
    onAddFiles: function () {
      this.$refs.uploadFiles.click()
    },
    addFilesToUpload: function (event) {
      const newFiles = event.target.files

      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i]
        this.tabFilesToUpload.push({ name: file.name, size: file.size })
        file.blob = ''
        const URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          file.blob = URL.createObjectURL(file)
        }
        this.filesToUpload.push(file)
      }

      this.$emit('files-to-upload-changed', this.filesToUpload)
    },
    downloadFileByURI: function (uri, name) {
      const link = document.createElement('a')
      link.setAttribute('download', name)
      link.href = uri
      document.body.appendChild(link)
      link.click()
      link.remove()
    },
    deleteFileFromServer: function (file, index) {
      this.loading = true

      axiosPost({
        url: '/service/delta/document/deleteFromObject?objectId=' + this.reportRoadsId + '&id=' + file.id,
        onSuccess: (response) => {
          this.$q.notify({
            type: 'positive',
            message: 'Файл удален',
            progress: true,
            timeout: 3000
          })

          this.reportRoadsFiles.splice(index, 1)
        },
        onFailure: 'Ошибка удаления файла',
        msgTarget: this
      }).finally(() => {
        this.loading = false
      })
    },
    deleteFileFromFilesToUpload: function (index) {
      this.filesToUpload.splice(index, 1)
      this.tabFilesToUpload.splice(index, 1)
      this.$emit('files-to-upload-changed', this.filesToUpload)
    },
    onSelectServiceObjectFiles: function () {
      this.$emit('select-service-object-files')
    }
  }
}

